import React from "react";
import PageHeader from "../pageHeader/PageHeader";

const WithPageHeader = ({ ...props }) => {
  return <PageHeader {...props} />;
};

export default WithPageHeader;
